module.exports = __webpack_public_path__ + "static/media/readdead.f26b4233.png";